import {BasicConfigStructure} from '../basic-config-structure.model';

export class FilterQueryConfig extends BasicConfigStructure {

  static ALL = ['work', 'work_work', 'work_materialization', 'museum_object', 'archive_object',"materialization"];

  minElements = 1;
  types: string[] = [];
  useKeyword = true;

  constructor(
    attr: {
      name?: string,
      show?: boolean,
      translation?: string,
      limitNestedIteration?: number,
      types?: string[],
      minElements?: number,
      useKeyword?: boolean;
    }) {
    super(attr);
    if (attr.types) {
      attr.types.forEach(type => this.types.push(type))
    } else {
      this.types = FilterQueryConfig.ALL;
    }
    if (attr.minElements != null) {
      this.minElements = attr.minElements;
    }
    if (attr.useKeyword != undefined) {
      this.useKeyword = attr.useKeyword;
    }
  }
}
